import React from 'react';
import * as Routes from '@/modules/routes';
import I18n from '@/modules/i18n';
import DropdownButton from '@/components/ui/Dropdown/DropdownButton';
import readingLevelIcon from 'images/icons/reading-level.svg';
import ButtonWithDropdown from '../Button/ButtonWithDropdown';

type IReadingLevel = 'a' | 'b';

interface ReadingLevelButtonProps {
  inIframe?: boolean;
  programId: number;
  readingLevel: IReadingLevel;
  sectionId: number;
}

const ReadingLevelButton = ({
  inIframe = false, programId, readingLevel, sectionId,
}: ReadingLevelButtonProps) => {
  const pathForReadingLevel = (level: IReadingLevel) => (
    Routes.shared_section_path(sectionId, {
      in_iframe: inIframe,
      program_id: programId,
      reading_level: level,
    })
  );

  return (
    <div className="tw-flex">
      <ButtonWithDropdown
        ariaLabel={I18n.t('select_reading_level')}
      >
        <ButtonWithDropdown.ButtonContent>
          <img
            alt="Select reading level"
            className="standard"
            src={readingLevelIcon}
          />
        </ButtonWithDropdown.ButtonContent>
        <ButtonWithDropdown.DropdownContent>
          <>
            {['a', 'b'].map((level: IReadingLevel) => (
              <DropdownButton
                key={level}
                checkmarkPlacement="left"
                href={pathForReadingLevel(level)}
                selected={readingLevel.toLocaleLowerCase() === level}
                title={`English reading level ${level.toUpperCase()}`}
                type="link"
              >
                <span>{level.toUpperCase()}</span>
              </DropdownButton>
            ))}
          </>
        </ButtonWithDropdown.DropdownContent>
      </ButtonWithDropdown>
    </div>
  );
};

export default ReadingLevelButton;
